<template>
    <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 .76v24m-12-12h24" stroke="#545E61" stroke-width="1.6" />
    </svg>
</template>
